import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Box, Typography } from '@curves/ui-base';

import Actions from '@Local/Components/Layout/Actions';
const PageHeader = ({ className, title, actions, children, ...rest }) => {
    return (
        <Box component={'header'} className={clsx('page-header', className)} {...rest}>
            <Typography className={'page-header-title'} variant={'h3'}>
                {title}
            </Typography>
            {children}
            {actions && <Actions actions={actions} />}
        </Box>
    );
};
PageHeader.prototype = {
    ...Actions.prototype,
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
};
export default PageHeader;
